"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TimeRange: function() {
        return TimeRange;
    },
    toTimeRangeString: function() {
        return toTimeRangeString;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _TimeDisplay = require("./TimeDisplay");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const toTimeRangeString = (param)=>{
    let { start, end, timezone, language } = param;
    const startString = (0, _TimeDisplay.toTimeString)({
        datetime: start,
        timezone,
        language
    });
    const endString = (0, _TimeDisplay.toTimeString)({
        datetime: end,
        timezone,
        language
    });
    return "".concat(startString, " - ").concat(endString);
};
const TimeRange = (param)=>{
    let { start, end, timezone, language } = param;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_TimeDisplay.TimeDisplay, {
        datetime: start,
        timezone: timezone,
        language: language
    }), " -", " ", /*#__PURE__*/ _react.default.createElement(_TimeDisplay.TimeDisplay, {
        datetime: end,
        timezone: timezone,
        language: language
    }));
};

//# sourceMappingURL=TimeRange.js.map